// All eight entries render the same sentence, so they share one translation key
// rather than eight identical ones. The values are KEYS, not copy: every consumer
// either assigns one to a bot `message` (resolved by checkTranslation in the
// messages-slice reducers) or wraps it in t() at the render site.
//
// The names are kept so the call sites still read as which branch they belong to.
const SELECT_FROM_AVAILABLE_OPTIONS = "selectFromAvailableOptions";

export const textConstants = {
  tourNotAvail: SELECT_FROM_AVAILABLE_OPTIONS,
  dataNotAvail: SELECT_FROM_AVAILABLE_OPTIONS,
  timeNotAvail: SELECT_FROM_AVAILABLE_OPTIONS,
  bedroomNotAvail: SELECT_FROM_AVAILABLE_OPTIONS,
  budgetNotAvail: SELECT_FROM_AVAILABLE_OPTIONS,
  moveInNotAvail: SELECT_FROM_AVAILABLE_OPTIONS,
  datesNotAvail: SELECT_FROM_AVAILABLE_OPTIONS,
  multiOptNotAvail: SELECT_FROM_AVAILABLE_OPTIONS,
};
